"use client";

import { sendGTMEvent } from "@next/third-parties/google";

import { GTagEvents } from "./types";

export const loginEvent = () => {
  sendGTMEvent({
    event: GTagEvents.LOGIN,
  });
};
